import { ColumnDef } from '@tanstack/react-table'
import { GetGameListTableData } from '@/modules/game/type'
import { IsActiveGame } from './components/CellAction/IsActive'
import { IsPopularGame } from './components/CellAction/IsPopular'
import EditOrder from './components/CellAction/EditOrder'
import EditNameGame from './components/CellAction/EditGameName'
import { IsNewGame } from './components/CellAction/IsNew'
import EditGameImage from './components/CellAction/EditGameImage'
import EditDefaultPreset from './components/CellAction/EditDefaultPreset'
import EditDefaultPresetNumber from './components/CellAction/EditDefaultPresetNumber'
import { SwitchToOpposite } from './components/CellAction/SwitchToOpposite'
import { getProviderPresetType, PresetType } from '@/modules/game/utils'

export const columns: ColumnDef<GetGameListTableData>[] = [
	{
		accessorKey: 'order',
		header: 'ลำดับ',
	},
	{
		accessorKey: 'displayName',
		header: 'ชื่อเกม',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				<span>{row.original.displayName || row.original.name}</span>
				<EditNameGame row={row.original} />
			</div>
		),
	},
	{
		accessorKey: 'imageUrl',
		header: 'รูปภาพ',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				{row.original.imageUrl ? (
					<div className="h-12 w-9 overflow-hidden rounded border">
						<img
							src={row.original.imageUrl}
							alt={row.original.displayName || row.original.name}
							className="h-full w-full object-cover"
						/>
					</div>
				) : (
					<div className="flex h-12 w-9 items-center justify-center rounded border bg-gray-200 text-xs text-gray-500">
						ไม่มี
					</div>
				)}
				<EditGameImage row={row.original} />
			</div>
		),
	},
	{
		accessorKey: 'type',
		header: 'ประเภทเกม',
	},
	{
		accessorKey: 'provider.name',
		header: 'ผู้ให้บริการ',
	},
	{
		accessorKey: 'isActive',
		header: 'สถานะ',
		cell: ({ row }) => <IsActiveGame row={row.original} />,
	},
	{
		accessorKey: 'isPopular',
		header: 'ยอดนิยม',
		cell: ({ row }) => <IsPopularGame row={row.original} />,
	},
	{
		accessorKey: 'isNew',
		header: 'เกมใหม่',
		cell: ({ row }) => <IsNewGame row={row.original} />,
	},
	{
		accessorKey: 'defaultPreset',
		header: 'RTP ตั้งต้น',
		cell: ({ row }) => {
			const providerName = ((row.original as any).provider?.name ||
				'') as string
			const presetType = getProviderPresetType(providerName)
			if (presetType === PresetType.PresetId) {
				return <EditDefaultPreset row={row.original} />
			}
			if (presetType === PresetType.PresetNumber) {
				return <EditDefaultPresetNumber row={row.original} />
			}
			const displayValue = row.original.defaultPreset
				? row.original.defaultPreset
				: row.original.defaultPresetNumber
					? `${row.original.defaultPresetNumber}%`
					: '-'
			return <span className="text-sm">{displayValue}</span>
		},
	},
	{
		accessorKey: 'switchToOpposite',
		header: () => (
			<div className="flex flex-col gap-1">
				<span>สลับเวอร์ชั่น</span>
				<span className="text-xs font-normal text-muted-foreground">
					(ใหม่ ⇄ เริ่มต้น)
				</span>
			</div>
		),
		cell: ({ row }) => {
			// Access provider.name safely (exists in runtime but not in type definition)
			const providerName = ((row.original as any).provider?.name ||
				'') as string
			return (
				<>
					{['PGHARD', 'JOKERHARD', 'JILIHARD', 'PG', 'JOKER', 'JILI'].includes(
						providerName,
					) ? (
						<SwitchToOpposite row={row.original} />
					) : (
						<span className="text-sm text-gray-400">-</span>
					)}
				</>
			)
		},
	},
	{
		accessorKey: 'action',
		header: 'แก้ไขลำดับ',
		cell: ({ row }) => <EditOrder row={row.original} />,
	},
]
